import { Check } from 'lucide-react'
import { TopicOptionsType } from '.'
import { Column, Row, Show, Text } from '@/components/core'
import { classNameBuilder } from '@/helpers'

interface TopicSelectorOptionButtonProps {
  option: TopicOptionsType
  isSelected: boolean
  handleOptionSelected: (id: string, label: string) => void
}

const TopicSelectorOptionButton = ({
  option,
  isSelected,
  handleOptionSelected
}: TopicSelectorOptionButtonProps) => {
  return (
    <button
      onClick={() => handleOptionSelected(option.id, option.label)}
      className={classNameBuilder(
        'h-fit w-fit rounded-full px-3 py-0.5 transition-colors duration-300 xxs:px-4 xxs:py-1 md:px-8 md:py-2.5',
        isSelected ? 'bg-white' : ' bg-electric-indigo-900'
      )}
    >
      <Row className="items-center space-x-1 md:space-x-3">
        <Column className={classNameBuilder(isSelected ? 'mx-0' : 'mx-4')}>
          <Text
            className={classNameBuilder(
              isSelected ? 'text-electric-indigo-900' : 'text-white',
              'text-sm md:text-base'
            )}
          >
            {option.label}
          </Text>
        </Column>
        <Show when={isSelected}>
          <Column className="w-fit">
            <Check
              size={20}
              strokeWidth={2.5}
              color="#09E16C"
              className="h-4 w-4 transition-colors duration-300 md:h-5 md:w-5"
            />
          </Column>
        </Show>
      </Row>
    </button>
  )
}

export default TopicSelectorOptionButton
